import { useTranslation } from 'react-i18next';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { AddedItemsList } from '@/shared/components/added-items-list';

type Props = {
  memberIdsToInvite: string[];
  orgMembers: OrgMemberWithProfile[];
  onRemove: (id: string) => void;
};

export const ProjectMemberInvitationList = ({
  memberIdsToInvite,
  orgMembers,
  onRemove,
}: Props) => {
  const { t } = useTranslation('project', {
    keyPrefix: 'InviteUsersForm.roles',
  });

  return (
    <ul className="space-y-4">
      {memberIdsToInvite.map((memberId) => {
        const orgMember = orgMembers.find(
          (orgMember) => orgMember.member_id === memberId,
        );

        return (
          <AddedItemsList
            key={memberId}
            items={[
              {
                id: memberId,
                title: orgMember?.profile?.email ?? 'Keine Angabe',
                subtitle: t('member'),
              },
            ]}
            onRemove={onRemove}
          />
        );
      })}
    </ul>
  );
};
